import { render, staticRenderFns } from "./fdInventory28.vue?vue&type=template&id=8f875ecc"
import script from "./fdInventory28.vue?vue&type=script&lang=js"
export * from "./fdInventory28.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports